import axios from 'axios';
import {baseApiUrl} from "../../../mainConfig.js";
const state = {
  accessToken: "",
  activeTabFlags: {
    "stakeholder_communication": {
      label: "Stakeholder Communication",
      value: true,
      newTab: true,
      link: "https://teams.microsoft.com/l/team/19%3a7126b741241a45e496ec2a837bf78553%40thread.tacv2/conversations?groupId=2183df77-13f2-479a-91f7-bd855fa687f2&tenantId=7f90057d-3ea0-46fe-b07c-e0568627081b",
      imageLink: "img/main_icons/stakeholdercomm_icon.png"
    },
    "management": {
      label: "Management",
      value: true,
      newTab: false,
      link: "https://irsp-under-construction.geodemosolutions.com/",
      imageLink: "img/main_icons/management_icon.png"
    },
    "design_collaboration": {
      label: "Design Collaboration",
      value: true,
      newTab: false,
      link: "",
      imageLink: "img/main_icons/design_icon.png"
    },
    "reporting": {
      label: "Reporting",
      value: true,
      newTab: false,
      link: "https://irsp-under-construction.geodemosolutions.com/",
      imageLink: "img/main_icons/report_icon.png"
    },
    "innovation": {
      label: "Innovation",
      value: true,
      newTab: false,
      link: "https://irsp-under-construction.geodemosolutions.com/",
      imageLink: "img/main_icons/innovation_icon.png"
    },
    "meetings_workshop": {
      label: "Meetings & Workshops",
      value: true,
      newTab: true,
      link: "https://arcadiso365.sharepoint.com/teams/InlandRail927/Meetings/Forms/AllItems.aspx",
      imageLink: "img/main_icons/meetings_icon.png"
    },
    "action_list": {
      label: "Meetings & Workshops",
      value: true,
      newTab: true,
      link: "https://arcadiso365.sharepoint.com/teams/InlandRail927/Lists/Action%20List/AllItems.aspx",
      imageLink: "img/main_icons/actionlist_icon.png"
    },
    "contact_list": {
      label: "Meetings & Workshops",
      value: true,
      newTab: true,
      link: "https://arcadiso365.sharepoint.com/teams/InlandRail927/Lists/Contact%20List/AllItems.aspx",
      imageLink: "img/main_icons/contactlist_icon.png"
    },
  },
  activeDesignCollabTabFlags: {
    gowrieToHelidonSection: false,
    helidonToCalvertSection: false,
    calvertToKagaruSection: false,
    commentingToolSection: false
  },
}
function initialState () {
  return {
    accessToken: "",
    activeTabFlags: {
      "stakeholder_communication": {
        label: "Stakeholder Communication",
        value: true,
        newTab: true,
        link: "https://teams.microsoft.com/l/team/19%3a7126b741241a45e496ec2a837bf78553%40thread.tacv2/conversations?groupId=2183df77-13f2-479a-91f7-bd855fa687f2&tenantId=7f90057d-3ea0-46fe-b07c-e0568627081b",
        imageLink: "img/main_icons/stakeholdercomm_icon.png"
      },
      "management": {
        label: "Management",
        value: true,
        newTab: false,
        link: "https://irsp-under-construction.geodemosolutions.com/",
        imageLink: "img/main_icons/management_icon.png"
      },
      "design_collaboration": {
        label: "Design Collaboration",
        value: true,
        newTab: false,
        link: "",
        imageLink: "img/main_icons/design_icon.png"
      },
      "reporting": {
        label: "Reporting",
        value: true,
        newTab: false,
        link: "https://irsp-under-construction.geodemosolutions.com/",
        imageLink: "img/main_icons/report_icon.png"
      },
      "innovation": {
        label: "Innovation",
        value: true,
        newTab: false,
        link: "https://irsp-under-construction.geodemosolutions.com/",
        imageLink: "img/main_icons/innovation_icon.png"
      },
      "meetings_workshop": {
        label: "Meetings & Workshops",
        value: true,
        newTab: true,
        link: "https://arcadiso365.sharepoint.com/teams/InlandRail927/Meetings/Forms/AllItems.aspx",
        imageLink: "img/main_icons/meetings_icon.png"
      },
      "action_list": {
        label: "Meetings & Workshops",
        value: true,
        newTab: true,
        link: "https://arcadiso365.sharepoint.com/teams/InlandRail927/Lists/Action%20List/AllItems.aspx",
        imageLink: "img/main_icons/actionlist_icon.png"
      },
      "contact_list": {
        label: "Meetings & Workshops",
        value: true,
        newTab: true,
        link: "https://arcadiso365.sharepoint.com/teams/InlandRail927/Lists/Contact%20List/AllItems.aspx",
        imageLink: "img/main_icons/contactlist_icon.png"
      },
    },
    activeDesignCollabTabFlags: {
      gowrieToHelidonSection: false,
      helidonToCalvertSection: false,
      calvertToKagaruSection: false,
      commentingToolSection: false
    },
  }
}
const mutations = {
  storeAccessToken(state, payload) {
    state.accessToken = payload
  },
  setActiveTabFlag(state, payload) {
    Object.keys(state.activeTabFlags).forEach(item=>{
      state.activeTabFlags[item].value = false
    })
    state.activeTabFlags[payload].value = true
  },
  setActiveDesignCollabTabFlags(state, payload) {
    Object.keys(state.activeDesignCollabTabFlags).forEach(item=>{
      state.activeDesignCollabTabFlags[item] = false
    })
    state.activeDesignCollabTabFlags[payload] = true
  }
}
const actions = {
  async login({dispatch, commit}, payload) {
    return new Promise(function(resolve, reject) {
      let loginUrl = baseApiUrl+"login"
      let config = {
        responseType: 'json'
      }
      axios.post(loginUrl, payload, config).then(result=>{
        if (typeof(result.data) != "undefined" && typeof(result.data.successfulLogin)!= "undefined" && result.data.successfulLogin == true) {
          resolve(result.data.accessToken)
        }
        else {
          reject("Invalid Login")
        }
      })
    });
  }
}
const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
